import { useTranslation } from "react-i18next"

import { getCmsAssetsUrl } from "../../../helpers/general"
import VideoWithText from "../../VideoWithText/VideoWithText"

const assetsUrl = getCmsAssetsUrl()

const Header = () => {
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language || "en"

  const buttonLink = `/${currentLang}/configure`

  return (
    <VideoWithText
      videoSrc={`${assetsUrl}/images/ingeteamev/videos/HOME1920x966px3mbps-mezclados.mp4`}
      videoAlt={t("Vídeo de fondo")}
      title={t("Movilidad del futuro electrificada")}
      buttonType="link"
      buttonLabel={t("configurate now")}
      buttonLink={buttonLink}
    />
  )
}

export default Header
